import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import {DateField} from '@mui/x-date-pickers';

const StyledDateField = styled(DateField)`
  .MuiInputAdornment-sizeMedium {
    &:not(:has(~ .MuiInputAdornment-sizeMedium)) {
      .MuiIconButton-root {
        padding: ${props => props.theme.layout(3)};

        svg {
          font-size: ${props => props.theme.fontSize(18)};
        }
      }
    }
  }
  
  &.DateField-size-tiny {
    .DateField-clear {
      &.MuiInputAdornment {
        &-positionStart:first-of-type {
          margin-left: ${props => props.theme.layout(-3)};
        }

        &-positionEnd:last-of-type {
          margin-right: ${props => props.theme.layout(-3)};
        }
      }
    }
    
    .MuiInputAdornment-sizeMedium {
      &:not(:has(~ .MuiInputAdornment-sizeMedium)) {
        .MuiIconButton-root {
          svg {
            font-size: ${props => props.theme.fontSize(16)};
          }
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledDateField.propTypes = {
  theme: PropTypes.object
};

export default StyledDateField;
